import { SentryErrorComponent } from '@components/Fallback'
import { FeedGrid } from '@features/projects/components/projectComponents/FeedGrid'
import { createFileRoute, getRouteApi } from '@tanstack/react-router'

const routeApi = getRouteApi(
  '/_auth/o/$orgId/projects/$projectId/$workflowSessionId/monitor'
)

const MonitorRoute = () => {
  const params = routeApi.useParams()
  const { workflowSessionId } = params

  return <FeedGrid workflowSessionId={workflowSessionId} />
}

export const Route = createFileRoute(
  '/_auth/o/$orgId/projects/$projectId/$workflowSessionId/monitor'
)({
  component: MonitorRoute,
  beforeLoad: () => ({ getTitle: () => 'Monitor' }),
  errorComponent: SentryErrorComponent,
  loader: () => ({
    crumb: 'Monitor',
  }),
})
